import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export const PrescriberListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("prescriber_admin.filters.search")}
        />
      </Grid>
    </Grid>
  );
});
